var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4004,
    cy: 60.7998,
    r: 59.2,
    stroke: "#343434",
    strokeWidth: 1.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_5824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2049 59.7244L56.7168 53.4386C56.0562 53.0772 55.2755 53.0907 54.628 53.4743C53.9802 53.8583 53.5938 54.5368 53.5938 55.2897V67.7534C53.5938 68.5028 53.9778 69.18 54.6213 69.5644C54.9573 69.7652 55.3298 69.8659 55.7032 69.8659C56.0451 69.8659 56.3879 69.7814 56.7033 69.6116L68.1918 63.4342C68.8737 63.0672 69.2994 62.3583 69.3026 61.5834C69.3054 60.8086 68.8849 60.0965 68.2049 59.7244ZM56.641 66.1855V56.8703L65.227 61.5684L56.641 66.1855Z",
    fill: "url(#paint0_linear_81_5824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8163 51.6303L85.8187 51.6541C85.8342 51.8287 86.2012 55.9745 86.2016 60.137V64.0281C86.2016 68.1906 85.8342 72.3364 85.8187 72.511L85.8128 72.5641C85.762 72.9731 85.2633 76.6163 83.5395 78.4901C81.4711 80.7659 79.1383 81.0135 78.0168 81.1326L78.0159 81.1327C77.9088 81.1438 77.8112 81.1541 77.7243 81.1656L77.6334 81.1751C70.7589 81.675 67.3011 81.6465 67.3011 81.6465L67.2983 78.5992C67.7585 78.5964 70.7208 78.6198 77.37 78.1389C77.4684 78.1266 77.5771 78.1147 77.6945 78.1024C78.6657 77.9997 79.9959 77.8585 81.2909 76.4338C82.1307 75.5209 82.6564 73.2159 82.7857 72.2126C82.8175 71.8484 83.1539 67.8807 83.1539 64.0281V60.137C83.1539 56.2221 82.8076 52.1989 82.7845 51.939C82.6548 50.7516 82.1442 48.5585 81.319 47.6988L81.3067 47.6857C79.9789 46.2693 78.532 46.1043 77.5747 45.9952L77.5694 45.9946C77.475 45.9837 77.3871 45.9736 77.3065 45.9635C70.6205 45.4803 60.5622 45.4081 60.2012 45.4057L60.1875 45.4058C59.6393 45.4099 49.7109 45.4851 43.0323 45.9635C42.9622 45.9726 42.8867 45.9813 42.8061 45.9907L42.784 45.9932C41.8533 46.1007 40.4461 46.2634 39.1115 47.7313C38.3065 48.6065 37.7709 50.7718 37.6166 51.9537C37.5841 52.3254 37.2484 56.2887 37.2484 60.137V64.0281C37.2484 67.9347 37.5936 71.9492 37.6178 72.2245C37.7475 73.3885 38.2581 75.5439 39.0833 76.4037L39.1115 76.4338C40.3103 77.7524 41.8692 77.931 43.0081 78.0615L43.0085 78.0616C43.2331 78.087 43.4461 78.1116 43.6433 78.1437C45.9328 78.3564 49.2005 78.5089 53.2012 78.5992V81.6482C49.1211 81.5568 45.6828 81.3991 43.2997 81.1723L43.1795 81.1557C43.0586 81.1344 42.8828 81.1143 42.6784 81.0909L42.6618 81.089C41.324 80.9359 38.8369 80.651 36.87 78.4984C35.0684 76.604 34.6304 72.9493 34.5864 72.5375L34.5836 72.5114C34.5681 72.3368 34.2012 68.1906 34.2012 64.0281V60.137C34.2012 55.9745 34.5681 51.8283 34.5836 51.6541L34.5896 51.601C34.6407 51.1916 35.139 47.5484 36.8628 45.675C38.9607 43.3673 41.307 43.0963 42.4345 42.9662C42.5229 42.9559 42.6043 42.9467 42.6781 42.9368L42.7697 42.9273C49.7061 42.4274 60.0881 42.3592 60.192 42.3588L60.2012 42.3584L60.2103 42.3588C60.3142 42.3592 70.6962 42.4274 77.5707 42.9273L77.6616 42.9368C77.739 42.9471 77.8254 42.9571 77.9199 42.9678C79.0605 43.0975 81.4321 43.3681 83.524 45.5953C85.3339 47.4889 85.7723 51.2118 85.8163 51.6303Z",
    fill: "url(#paint1_linear_81_5824)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0703 73.6621L53.7324 87",
    stroke: "url(#paint2_linear_81_5824)",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0703 87L53.7324 73.6621",
    stroke: "url(#paint3_linear_81_5824)",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_5824",
    x1: 61.4482,
    y1: 53.1768,
    x2: 65.6245,
    y2: 74.4389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_81_5824",
    x1: 60.2014,
    y1: 42.3584,
    x2: 67.3244,
    y2: 93.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_81_5824",
    x1: 60.4014,
    y1: 73.6621,
    x2: 63.5563,
    y2: 90.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_81_5824",
    x1: 60.4014,
    y1: 73.6621,
    x2: 63.5563,
    y2: 90.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_5824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.0002,
    height: 52,
    fill: "white",
    transform: "translate(34.2012 36.0615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveChannelIcon);
export default __webpack_public_path__ + "static/media/RemoveChannelIcon.c92a68f2617470037bc8648f3cc6a484.svg";
export { ForwardRef as ReactComponent };